import React, { useState } from 'react';

const phases = [
  {
    id: 1,
    name: 'Architecture & Testing',
    dates: 'Now → May 1st',
    status: 'active',
    tasks: [
      { text: 'Finalise Supabase schema', done: true },
      { text: 'GitHub Actions scripts drafted', done: true },
      { text: 'Dry test: Retentionist agent (log mode)', done: true },
      { text: 'Dry test: Alchemist agent (log mode)', done: false },
      { text: 'Record 7-reel backlog', done: false },
      { text: 'Command Center dashboard live', done: true },
    ],
  },
  {
    id: 2,
    name: 'Hype Waitlist',
    dates: 'May 1st → May 19th',
    status: 'upcoming',
    tasks: [
      { text: 'Launch landing page with waitlist CTA', done: false },
      { text: 'Activate Ambassador Boss for waitlist sharing', done: false },
      { text: 'Resend welcome sequence for waitlist', done: false },
      { text: 'MedSoc president outreach (5 universities)', done: false },
      { text: 'Waitlist target: 500 signups', done: false },
    ],
  },
  {
    id: 3,
    name: 'UCAT Independence Day',
    dates: 'May 20th 🚀',
    status: 'upcoming',
    tasks: [
      { text: 'Flip all agents from Test → Live mode', done: false },
      { text: 'Open platform to waitlist first', done: false },
      { text: 'Send "You\'re in" emails via Resend', done: false },
      { text: 'Post launch Reel across all channels', done: false },
      { text: 'Founder: 10 mins/day approvals + 20 mins content', done: false },
    ],
  },
  {
    id: 4,
    name: 'Monetisation',
    dates: 'Post-scale',
    status: 'upcoming',
    tasks: [
      { text: 'Introduce Premium Tier (Unlimited Alchemist)', done: false },
      { text: 'Keep core question bank free forever', done: false },
      { text: 'University partnership deals', done: false },
      { text: 'NHS / FY1 doctor tier (My Medicine Friend)', done: false },
    ],
  },
];

const infraStack = [
  { name: 'AI Brain', tool: 'Google AI Studio (Gemini 2.5)', cost: '£0', limit: '1,500 req/day', icon: '🧠' },
  { name: 'Automation', tool: 'GitHub Actions', cost: '£0', limit: '2,000 min/month', icon: '⚡' },
  { name: 'Database', tool: 'Supabase', cost: '£0', limit: '500MB / millions of rows', icon: '🗄' },
  { name: 'Email', tool: 'Resend API', cost: '£0', limit: '3,000 emails/month', icon: '✉️' },
  { name: 'Hosting', tool: 'Cloudflare Pages', cost: '£0', limit: 'Unlimited bandwidth', icon: '🌐' },
];

export default function Launchpad() {
  const [tasks, setTasks] = useState(phases);

  const toggleTask = (phaseId, taskIdx) => {
    setTasks(prev => prev.map(p => p.id !== phaseId ? p : {
      ...p,
      tasks: p.tasks.map((t, i) => i !== taskIdx ? t : { ...t, done: !t.done })
    }));
  };

  const getProgress = (phase) => {
    const done = phase.tasks.filter(t => t.done).length;
    return Math.round((done / phase.tasks.length) * 100);
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Launchpad</div>
          <div className="page-subtitle">Phase tracker, infrastructure stack, and launch checklist</div>
        </div>
        <div style={{fontSize:'12px',color:'var(--text-3)'}}>
          May 20th Launch · <span style={{color:'var(--accent-mmf)',fontWeight:'600'}}>Phase 1 Active</span>
        </div>
      </div>

      {/* Phase tracker */}
      <div className="section-label" style={{marginBottom:'16px'}}>Launch Phases</div>
      <div style={{display:'flex',flexDirection:'column',gap:'14px',marginBottom:'32px'}}>
        {tasks.map(phase => {
          const progress = getProgress(phase);
          return (
            <div key={phase.id} className="card" style={{
              borderColor: phase.status === 'active' ? 'rgba(0,212,170,0.25)' : 'var(--border)',
              background: phase.status === 'active' ? 'linear-gradient(135deg, rgba(0,212,170,0.04) 0%, var(--bg-1) 50%)' : 'var(--bg-1)',
            }}>
              <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:'12px'}}>
                <div style={{display:'flex',gap:'12px',alignItems:'center'}}>
                  <div className={`phase-dot ${phase.status}`} style={{width:'12px',height:'12px',marginTop:'0'}} />
                  <div>
                    <div style={{fontFamily:'var(--font-display)',fontSize:'15px',fontWeight:'800',color:'var(--text)',letterSpacing:'-0.01em'}}>
                      Phase {phase.id}: {phase.name}
                    </div>
                    <div style={{fontSize:'11px',color:'var(--text-3)',marginTop:'2px'}}>{phase.dates}</div>
                  </div>
                </div>
                <div style={{textAlign:'right'}}>
                  <div style={{fontFamily:'var(--font-display)',fontSize:'20px',fontWeight:'800',color: phase.status === 'active' ? 'var(--accent-m)' : 'var(--text-3)'}}>
                    {progress}%
                  </div>
                  <div style={{fontSize:'10px',color:'var(--text-3)'}}>complete</div>
                </div>
              </div>

              <div style={{background:'var(--bg-3)',borderRadius:'10px',height:'3px',marginBottom:'14px',overflow:'hidden'}}>
                <div style={{
                  height:'100%',
                  width:`${progress}%`,
                  background: phase.status === 'active' ? 'var(--accent-m)' : 'var(--text-3)',
                  borderRadius:'10px',
                  transition:'width 0.3s',
                }}/>
              </div>

              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'6px'}}>
                {phase.tasks.map((task, i) => (
                  <div
                    key={i}
                    style={{display:'flex',gap:'8px',alignItems:'flex-start',cursor:'pointer',padding:'4px 0'}}
                    onClick={() => toggleTask(phase.id, i)}
                  >
                    <div style={{
                      width:'14px',height:'14px',borderRadius:'3px',flexShrink:0,marginTop:'1px',
                      background: task.done ? 'var(--green)' : 'transparent',
                      border: task.done ? '1px solid var(--green)' : '1px solid var(--border-bright)',
                      display:'flex',alignItems:'center',justifyContent:'center',
                    }}>
                      {task.done && <svg width="8" height="8" viewBox="0 0 12 12" fill="none" stroke="white" strokeWidth="2"><polyline points="2,6 5,9 10,3"/></svg>}
                    </div>
                    <div style={{fontSize:'11px',color: task.done ? 'var(--text-3)' : 'var(--text-2)',textDecoration: task.done ? 'line-through' : 'none'}}>
                      {task.text}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>

      {/* Infrastructure stack */}
      <div className="section-label" style={{marginBottom:'16px'}}>Zero-Dollar Infrastructure Stack</div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:'12px',marginBottom:'24px'}}>
        {infraStack.map((item, i) => (
          <div key={i} className="card card-sm" style={{textAlign:'center'}}>
            <div style={{fontSize:'24px',marginBottom:'6px'}}>{item.icon}</div>
            <div style={{fontSize:'10px',letterSpacing:'0.06em',textTransform:'uppercase',color:'var(--text-3)',marginBottom:'4px'}}>{item.name}</div>
            <div style={{fontSize:'11px',color:'var(--text)',fontWeight:'600',marginBottom:'4px'}}>{item.tool}</div>
            <div style={{fontSize:'11px',color:'var(--green)',fontWeight:'700',marginBottom:'4px'}}>{item.cost}/mo</div>
            <div style={{fontSize:'9px',color:'var(--text-3)'}}>{item.limit}</div>
          </div>
        ))}
      </div>

      {/* Founder's daily schedule */}
      <div className="section-label" style={{marginBottom:'16px'}}>Founder Daily Schedule (Post-Launch)</div>
      <div className="card">
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:'0'}}>
          {[
            { time: '10 mins', task: 'Morning Pulse review + Approval Queue', icon: '☀️', color: 'var(--accent-m)' },
            { time: '20 mins', task: 'Record daily Reel from Studio Panel script', icon: '🎬', color: 'var(--accent-mmf)' },
            { time: '1 hour', task: 'Authentic community engagement on Instagram', icon: '💬', color: 'var(--accent-gold)' },
          ].map((item, i) => (
            <div key={i} style={{padding:'20px',borderRight: i < 2 ? '1px solid var(--border)' : 'none'}}>
              <div style={{fontSize:'24px',marginBottom:'10px'}}>{item.icon}</div>
              <div style={{fontFamily:'var(--font-display)',fontSize:'20px',fontWeight:'800',color:item.color,marginBottom:'4px'}}>{item.time}</div>
              <div style={{fontSize:'12px',color:'var(--text-3)',lineHeight:'1.55'}}>{item.task}</div>
            </div>
          ))}
        </div>
        <div style={{padding:'14px 20px',borderTop:'1px solid var(--border)',background:'var(--bg-2)',fontSize:'11px',color:'var(--text-3)',textAlign:'center'}}>
          AI handles everything else. You stay visionary. 🧠
        </div>
      </div>
    </div>
  );
}
